class SwiperComponent extends HTMLElement {
  constructor() {
    super()
    try {
      this.init()
    } catch (error) {
      console.error('Error occurred:', error)
    }
  }

  init() {
    const swiperElement = this.querySelector('.swiper')
    if (!window.Swiper || !swiperElement) return

    const { options, arrow, pagination } = this.dataset
    let swiperOptions = {}
    if (options) {
      swiperOptions = JSON.parse(options)
    }
    if (arrow == 'true') {
      swiperOptions = {
        navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev')
        },
        ...swiperOptions
      }
    }
    if (pagination == 'true') {
      swiperOptions = {
        pagination: {
          el: this.querySelector('.swiper-pagination')
        },
        on: {
          slideChangeTransitionEnd: () => {
            this.slideChange?.()
          }
        },
        ...swiperOptions
      }
    }
    this.swiper = new Swiper(swiperElement, swiperOptions)
  }

  slideTo(index, speed, runCallbacks) {
    this.swiper.slideTo(index, speed, runCallbacks)
  }
}
customElements.define('swiper-component', SwiperComponent)

class TabsComponent extends HTMLElement {
  constructor() {
    super()
    this.init()
  }

  init() {
    const tabsElement = this.querySelector('[data-tabs]')
    tabsElement.addEventListener('click', ({ target }) => {
      try {
        const tabElement = target.closest('[data-tab]')
        if (tabElement && tabsElement.contains(tabElement)) {
          const { index } = tabElement.dataset
          const tabElements = tabsElement.querySelectorAll('[data-tab]')

          Array.from(tabElements).forEach((element) => {
            if (element === tabElement) {
              element.classList.add('active')
            } else {
              element.classList.remove('active')
            }
          })

          const tabsContentElements = this.querySelectorAll('[data-tabs-content]')
          Array.from(tabsContentElements).forEach((element) => {
            if (element.dataset.index === index) {
              element.classList.remove('hidden')
            } else {
              element.classList.add('hidden')
            }
          })
        }
      } catch (error) {
        console.error('Error occurred:', error)
      }
    })
  }
}
customElements.define('tabs-component', TabsComponent)

class AnchorTargetText extends HTMLElement {
  constructor() {
    super()
    this.init()
  }

  init() {
    const anchorsElement = this.querySelector('[data-anchors]')
    if (!anchorsElement) return

    const anchorTargetElement = document.body

    anchorsElement.addEventListener('click', (event) => {
      try {
        const anchorElement = event.target.closest('[data-anchor]')
        if (anchorElement && anchorsElement.contains(anchorElement)) {
          const { anchorTargetText } = anchorElement.dataset
          const textContent = anchorTargetElement.textContent
          const index = textContent.indexOf(anchorTargetText)

          if (index !== -1) {
            this.handleTextAnchor(anchorTargetText, index, anchorTargetElement)
          } else {
            const imgElements = anchorTargetElement.querySelectorAll('img')
            for (const img of imgElements) {
              const altText = img.getAttribute('alt')
              if (altText && altText.includes(anchorTargetText)) {
                this.scrollToImage(img)
                break
              }
            }
          }
        }
      } catch (error) {
        console.error('Error occurred:', error)
      }
    })
  }

  handleTextAnchor(anchorTargetText, index, anchorTargetElement) {
    let textRange = document.createRange()
    let selection = window.getSelection()
    if (!selection) return
    selection.removeAllRanges()

    let { node: rangeStartNode, offset: rangeStartOffset } = this.findNodeAtOffset(anchorTargetElement, index)
    let { node: rangeEndNode, offset: rangeEndOffset } = this.findNodeAtOffset(
      anchorTargetElement,
      index + anchorTargetText.length
    )

    if (!rangeStartNode || !rangeEndNode) return

    textRange.setStart(rangeStartNode, rangeStartOffset)
    textRange.setEnd(rangeEndNode, rangeEndOffset)
    selection.addRange(textRange)

    let rect = textRange.getBoundingClientRect()
    let fixedHeaderHeight = document.querySelector('.shopify-section-header-sticky')?.offsetHeight || 0
    let scrollY = window.scrollY + rect.top - fixedHeaderHeight
    window.scrollTo({ top: scrollY, behavior: 'smooth' })
  }

  scrollToImage(img) {
    const rect = img.getBoundingClientRect()
    let fixedHeaderHeight = document.querySelector('.shopify-section-header-sticky')?.offsetHeight || 0
    let scrollY = window.scrollY + rect.top - fixedHeaderHeight
    window.scrollTo({ top: scrollY, behavior: 'smooth' })
  }

  // 处理文本偏移
  findNodeAtOffset(rootNode, targetOffset) {
    if (!rootNode || targetOffset < 0) {
      return { node: null, offset: 0 }
    }

    let totalLength = rootNode.textContent.length
    if (targetOffset >= totalLength) {
      return { node: null, offset: totalLength }
    }

    let currentOffset = 0

    function traverse(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        const nodeLength = node.textContent.length
        if (currentOffset + nodeLength > targetOffset) {
          return { node, offset: targetOffset - currentOffset }
        }
        currentOffset += nodeLength
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        for (const child of node.childNodes) {
          const result = traverse(child)
          if (result) return result
        }
      }
      return null
    }

    return traverse(rootNode) || { node: null, offset: 0 }
  }
}
customElements.define('anchor-target-text', AnchorTargetText)

class DropdownComponent extends HTMLElement {
  constructor() {
    super()
    this.getElements()
    this.setupEventListeners()
  }

  getElements() {
    this.elements = {
      input: this.querySelector(':scope > .dropdown__input'),
      list: this.querySelector(':scope > .dropdown__list')
    }
  }

  setupEventListeners() {
    if (this.elements.input && !this.elements.input.hasAttribute('hidden')) {
      this.elements.input.addEventListener('focus', this.onOpen.bind(this))
    } else {
      this.addEventListener('click', this.onOpen.bind(this))
    }
    const debouncedOnInput = debounce((event) => {
      this.onInputInput(event)
    }, ON_CHANGE_DEBOUNCE_TIMER)
    this.elements.input?.addEventListener('input', (event) => {
      event.stopPropagation()
      debouncedOnInput(event)
    })
    this.elements.list?.addEventListener('click', this.onListClick.bind(this))
    document.addEventListener('click', (event) => {
      if (!this.contains(event.target) || event.target.closest('dropdown-component') !== this) {
        this.removeAttribute('open')
      }
    })
  }

  onOpen(event) {
    if (event.target.closest('dropdown-component') !== this) return
    this.setAttribute('open', '')
  }

  onInputInput(event) {
    if (!this.hasAttributes('open')) this.onOpen(event)
    const value = event.target.value.toLowerCase()
    const itemsElements = this.querySelectorAll('.dropdown__item')
    Array.from(itemsElements).forEach((element) => {
      const itemValue = element.innerHTML.toLowerCase()
      if (!value.length || itemValue.includes(value) || value.includes(itemValue)) {
        element.classList.remove('hidden')
      } else {
        element.classList.add('hidden')
      }
    })
  }

  onListClick(event) {
    event.stopPropagation()

    const itemElement = event.target.closest('.dropdown__item')
    if (itemElement && event.currentTarget.contains(itemElement)) {
      if (this.elements.input) {
        this.elements.input.value = itemElement.dataset.value
        this.elements.input.dataset.param = itemElement.dataset.param
      }
      this.isClickingItem = false
      this.removeAttribute('open')

      this.dispatchEvent(
        new CustomEvent('dropdownItemSelected', {
          detail: { source: itemElement },
          bubbles: true
        })
      )
    }
  }
}
customElements.define('dropdown-component', DropdownComponent)
